module.exports = __webpack_public_path__ + "slick.ced611daf7709cc778da.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/assets/css/plugins/fonts/slick.eot
// module id = ../../../../../src/assets/css/plugins/fonts/slick.eot
// module chunks = styles